import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import useStateHandler from '@/hooks/useStateHandler';
import Text from '@/shared-components/text/components/Text';

import './styles/TemporalPopup.css';

export default function TemporalPopup() {
  const { state } = useStateHandler();
  const [temporalPopupStatus, setTemporalPopupStatus] = useState(null);
  const [active, setActive] = useState(false);
  const currentTimeout = useRef(null);

  useEffect(() => {
    if (state.temporalPopup) {
      setTemporalPopupStatus(state.temporalPopup);
      setActive(true);

      // Clear any existing timeout before starting a new one.
      if (currentTimeout.current) {
        clearTimeout(currentTimeout.current);
      }
      currentTimeout.current = setTimeout(() => setActive(false), 4000);
    }
  }, [state.temporalPopup]);

  // Check if the navbar is present by verifying if the type is "navbar-present".
  // When true, the "navbar-present" class is added to adjust the popup's position.
  const isNavbarPresent = temporalPopupStatus?.type === "navbar-present";
  const isError = temporalPopupStatus?.variant === "error";

  return createPortal(
    <div
      className={`temporal-popup__container ${active ? "active" : ""} ${isNavbarPresent ? "navbar-present" : ""} ${isError ? "temporal-popup__container--error" : ""} theme-active`}
    >
      <Text className="temporal-popup__text font-size-small" paragraph>
        {temporalPopupStatus?.text}
      </Text>
    </div>,
    document.getElementById("portal-temporal-popup")
  );
}
